$(document).ready(function($) {
    var currentTop = 0;

    function checkLastCardHeight() {

        if ($('#wpadminbar').length && $(window).outerWidth() > 600) {
            $('.block-cardstack .block-stackcard').attr('style', '--top: ' + parseFloat($('#wpadminbar').outerHeight()) + 'px;');
        } else {
            $('.block-cardstack .block-stackcard').attr('style', '--top: 0px;');
        }

        var lastChildHeight = parseFloat($('.block-cardstack .block-stackcard:last-child').outerHeight());

        $('.block-cardstack .block-stackcard:last-child').after('<div class="block-stackcard last" style="--top: 0px;height:' + lastChildHeight + 'px;"></div>');
        if ($('.block-cardstack').parent().hasClass('wp-block-group')) {
            $('.block-cardstack').parent().css({'z-index': '1', 'position': 'relative'});
            $('.block-cardstack').parent().next().css({'margin-top' : (lastChildHeight * -1) + 'px', 'z-index':'2'});
        } else {
            $('.block-cardstack').css({'margin-top' : (lastChildHeight * -1) + 'px'});
            $('.block-cardstack').next().css({'margin-top' : (lastChildHeight * -1) + 'px', 'z-index':'2'});
        }

    }

    checkLastCardHeight();

    window.addEventListener('resize', function() {
        $('.block-stackcard.last').remove();
        checkLastCardHeight();
    });

    // $.each($('.block-stackcard'), function() {
    //     console.log('stackcard', $(this));
    //     if ($(this).prev('.block-stackcard').length) {
    //         var prevCardHeaderHeight = parseFloat($(this).prev('.block-stackcard').find('.wp-block-columns').outerHeight());
    //         $(this).attr('style', '--top: ' + (parseFloat(currentTop) + prevCardHeaderHeight) + 'px;');
    //         currentTop += prevCardHeaderHeight;
    //     }
    // });
    // var prevCardHeaderHeight = parseFloat($('.block-stackcard:last-child').find('.wp-block-columns').outerHeight());
    // $('.block-stackcard:last-child').after('<div class="block-stackcard-spacer" style="--top: ' + (parseFloat(currentTop) + prevCardHeaderHeight) + '"></div>');
});